/**
 * Application Constants
 *
 * These come from the server via the `#__config` data island, which derives them
 * from the ECS task env (`ARTWORK_LOWMID_ROOT` / `STATIC_ASSET_ROOT`, see
 * apps/pictufy/src/views/assets.ts). They were previously hardcoded here, which
 * meant a non-production environment silently got production URLs from roughly
 * half the codebase — the modals used these literals while Dashboard.tsx,
 * newsletter.ts and directoryUpload.ts read `config.*`.
 *
 * The literals survive only as the fallback for when the island is missing or a
 * value is empty (e.g. local dev with an unset env var).
 */
import { config } from "../config";

/** Root URL for artwork images (server: `ARTWORK_LOWMID_ROOT`). */
export const IMG_ROOT = config.imgRoot || "https://files.pictufy.com/";

/** Root URL for static assets — FontAwesome, favicons, images (server: `STATIC_ASSET_ROOT`). */
export const ASSET_ROOT = config.assetRoot || "https://static.pictufy.com/";

/**
 * Backend URL for mockup/interior rendering. Normally supplied by the server via
 * the `#__config` island; the fallback is the same-origin route the server mounts
 * (`/mockup-render`), used when the island is missing or empty.
 */
export const MOCKUP_BACKEND_URL = config.mockupBackendUrl || "/mockup-render";
